import { render, staticRenderFns } from "./spiderChart.vue?vue&type=template&id=ea05fbbc&"
import script from "./spiderChart.vue?vue&type=script&lang=js&"
export * from "./spiderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports